<template>
    <div class="m-top">
        <div style="padding: .3rem;box-sizing: border-box;"><img src="@/assets/images/logo_blue1.png" alt="" style="height: 1rem;max-height: 40px;"></div>
        <ul class="flex" style="position: relative;">
            <li :class="{'m-li':1,'m-fo':$store.state.menuInd==n}" v-for="(menu,n) of menuList" :key="'menu'+n" @click="handleRoute(menu,n)">{{menu.name}}</li>   
            <div class="sub-menu" v-if="tabIndex==1">
                <div class="flex flex-bt" style="padding: .3rem;box-sizing: border-box;">
                    <img src="@/assets/images/logo_blue1.png" alt="" style="height: 1rem;max-height: 40px;">
                    <span @click="tabIndex=0"><i class="el-icon-close" style="font-size: 1rem;"></i></span>
                </div>
                <div style="padding: 1rem;box-sizing: border-box;">
                    <div v-for="(item,k) of productArr" 
                    :key="'item'+k" 
                    class="flex" 
                    style="font-size: .6rem;height: 1.5rem;line-height: 1.5rem;" 
                    @click="clickProduct(item)">
                        <img :src="item.logo" alt="" style="height: .8rem;"><span style="margin-left: 8px;">{{item.productName}}</span>
                    </div>
                </div>
            </div>  
            <div class="sub-menu" v-if="tabIndex==2">
                <div class="flex flex-bt" style="padding: .3rem;box-sizing: border-box;">
                    <img src="@/assets/images/logo_blue1.png" alt="" style="height: 1rem;max-height: 40px;">
                    <span @click="tabIndex=0"><i class="el-icon-close" style="font-size: 1rem;"></i></span>
                </div>
                <div style="padding: 1rem;box-sizing: border-box;">
                    <div v-for="(item,k) of planArr" 
                    :key="'item'+k" 
                    class="flex" 
                    style="font-size: .6rem;height: 1.5rem;line-height: 1.5rem;" 
                    @click="clickPlan(item)">
                        {{item.schemeName}}
                    </div>
                </div>
            </div>          
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return{            
            menuList:[
                {name:'首页',href:'phoneIndex'},
                {name:'产品',href:'phoneProduct',
                    list:[
                        {name:'BIMeta管综',href:'phoneProduct'},
                        {name:'BIMeta快模',href:'phoneProduct'},
                        {name:'BIMeta协同',href:'phoneProduct'},
                        {name:'BIMeta管网',href:'phoneProduct'},
                        {name:'BIMeta报建',href:'phoneProduct'},
                        {name:'BIMeta云族',href:'phoneProduct'},
                        {name:'千面AI数字专家软件',href:'phoneProduct'},
                        {name:'BIMeta数字化交付',href:'phoneProduct'},
                        {name:'BIMeta工规报建',href:'phoneProduct'},
                        {name:'极视CIM可视化汇报平台',href:'phoneProduct'},
                        {name:'BIMeta软件集合',href:'phoneProduct'}
                    ],
                },
                {name:'方案',href:'phonePlan',
                    list:[
                        {name:'极智数字管网解决方案',href:'phonePlan'},
                        {name:'极智数字报建解决方案',href:'phonePlan'},
                        {name:'极智智能管综解决方案',href:'phonePlan'},
                        {name:'极智数字资源管理解决方案',href:'phonePlan'},
                        {name:'CIM数字汇报解决方案',href:'phonePlan'},
                        {name:'360全景数字巡检解决方案',href:'phonePlan'}
                    ]
                },
                // {name:'下载',href:'phoneDownload'},
                {name:'学习',href:'https://space.bilibili.com/1120539006'},
                {name:'案例',href:'phoneCase'},
                {name:'新闻',href:'phoneNews'},
                {name:'关于',href:'phoneAbout'}
            ],
            tabIndex:0,

            productArr:[],
            planArr:[],
            
        }        
    },
    created(){
        this.getProduct()
        this.getPlan()
    },
    mounted(){},
    methods:{
        getProduct(){            
			this._get(this.API.productList + "?pageNo=1&pageSize=100").then((res) => {
                console.log('cpcpcpcpcppc',res.data)
				if (res.code == 200) {			
					this.productArr = res.data.records;
				}
			});		
        },
        getPlan(){
            this._get(this.API.planList+'?pageNo=1&pageSize=100').then((res) => {                
                if (res.code == 200) {
                    this.planArr = res.data.records;
                }
            })
        },
        clickProduct(pro){
            this.tabIndex = 0             
            this.$router.push({ name: "empty" });  
            setTimeout(()=>{
                this.$store.dispatch("setMenuInd",1)  
                this.$router.push({ name: "phoneProduct", query: { id:pro.id } });
                window.scrollTo(0, 0);
            },0)             
        },
        clickPlan(plan){
            this.tabIndex = 0
            this.$router.push({ name: "empty" });  
            setTimeout(()=>{
                this.$store.dispatch("setMenuInd",2)  
                this.$router.push({ name: "phonePlan", query: { id:plan.id } });
                window.scrollTo(0, 0);
            },0)
        },
        handleRoute(menu,n){
            if(n==1){//产品
                this.tabIndex=1
            }else if(n==2){//方案
                this.tabIndex=2
            }else if(n==3){
                window.open(menu.href)                
            }else{
                this.$store.dispatch("setMenuInd",n)          
                this.$router.push({name:menu.href})
                window.scrollTo(0, 0);
            }
        },
    },
}
</script>
<style scoped>
    .m-top{
        position: fixed;
        z-index: 999;
        width: 100%;
        height: 3.2rem;
        background-color: #FFF;
        box-shadow: 0 1px 1px #f9f9f9;
    }
.m-li{
    padding: 0 10px;
    height: 40px;
    line-height: 40px;
    font-size: .58rem;
}
.m-fo{
    color: #0044fd;
}
.sub-menu{
    position: fixed;
    z-index: 1000;
    width: 100%;
    height: 100%;
    left: 0;
    top:0;
    background-color: #FFF;
}
</style>
